import { ReactNode } from 'react';

import { Assets, Flex, Headings, SpeechBubble } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

type ReportingActionBoxProps = {
  variant: 'info' | 'approved' | 'action';
  children: ReactNode;
};

export const ReportingActionBox = ({ variant, children }: ReportingActionBoxProps) => {
  const { t } = useTypedTranslation();
  return (
    <SpeechBubble
      color={variant === 'info' ? 'babyBlue' : variant === 'action' ? 'babyYellow' : 'babyGreen'}
      illustration={<Assets.CheckmarkBubbleIllustration width={34} />}
    >
      <Flex flexDirection="column" rowGap={20}>
        <Headings.H3>
          {variant === 'approved' ? t('section.employerActions.titleAllDone') : t('section.employerActions.title-1')}
        </Headings.H3>
        {children}
      </Flex>
    </SpeechBubble>
  );
};

export const ReportingActionBoxSubSection = ({ children }: { children: ReactNode }) => (
  <Flex flexDirection="column" rowGap={6}>
    {children}
  </Flex>
);
